<template>
	
	<div style="width:580px;margin:20px auto 0 auto;display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center">

          <el-form ref="form" :model="bonForm" label-width="100px" v-loading="layLoading" :rules="rules">
            
            <el-form-item :label="$t('msg.아이디')" class="mb-0" prop="mem_id">
              <el-autocomplete v-model="bonForm.mem_id" :fetch-suggestions="querySearchAsync" :trigger-on-focus="false" @select="handleSelect" class="w-50"></el-autocomplete><el-button type="primary" @click="userbalance_btn" plain class="ml-1">{{$t('tableText.조회')}}</el-button>
            </el-form-item>
           
           <el-form-item label="" v-if="this.sitetype=='4'" class="mb-0 userbalance">
          <div class="d-flex align-items-center justify-content-center">
            <div v-for="(item,index) in money_label" :key="index" :index="index" class="mr-2">
             {{index}}:<span class="text-primary ml-1"> {{formatMoney(item)}}</span>
            </div>
          </div>
            </el-form-item>

            <el-form-item label="" v-if="this.sitetype=='2' || this.sitetype=='1'" class="mb-0 userbalance">
       
             
              {{$t('msg.게임머니')}}:<span class="text-primary mr-1">{{formatMoney(mem_cash)}}</span>
              {{$t('msg.이벤트머니')}}:<span class="text-primary mr-1">{{formatMoney(mem_eventmoney)}}</span>
            
            </el-form-item>

             <el-form-item label="" v-if="this.sitetype=='3'" class="mb-0 userbalance">
       
             
              {{$t('msg.게임머니')}}:<span class="text-primary mr-1">{{formatMoney(mem_cash)}}</span>
              {{$t('msg.이벤트머니')}}:<span class="text-primary mr-1">{{formatMoney(mem_eventmoney)}}</span>
               {{$t('msg.롤링머니')}}:<span class="text-primary mr-1">{{formatMoney(mem_ing)}}</span>
            
            </el-form-item>

             <el-form-item :label="$t('searchText.구분')" class="mb-0 " >
              <el-select :placeholder="$t('status.선택')" v-model="gubun" class="w-75 typeIco">
                  <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('tableText.타입')" class="mb-0 ">
              <el-select :placeholder="$t('status.선택')" v-model="io_type" class="w-75 typeIco">
                  <el-option
                  v-for="item in ioType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('tableText.금액')" class="mb-0" prop="money">
               <div class="d-flex" style="align-items:center">
             <el-input 
  v-model="bonForm.money" 
  type="number"  
  class="w-75"
  :disabled="bonForm.all == '1'"
></el-input>
               <div v-if="this.io_type == '2'" style="position:absolute;right:-30px">
              <span style="display:inline-block;width:40px;text-align:center">전액</span> <el-switch v-model="bonForm.all" active-value="1" ></el-switch></div>
            </div>
            </el-form-item>

             <el-form-item :label="$t('tableText.메모')" class="mb-0">
              <el-input v-model="bonForm.memo" type="text"  class="w-75"></el-input>
            </el-form-item>
          <el-form-item label="" class="mb-0" style="margin-left:-100px">
             <el-button type="primary" size="mini" plain style="margin-left:3px;padding:7px 8px" @click="getVal('10000')">1{{$t('tableText.만원')}}</el-button>
             <el-button type="primary" size="mini" plain style="margin-left:3px;padding:7px 8px" @click="getVal(50000)">5{{$t('tableText.만원')}}</el-button>
             <el-button type="primary" size="mini" plain style="margin-left:3px;padding:7px 8px" @click="getVal(100000)">10{{$t('tableText.만원')}}</el-button>
             <el-button type="primary" size="mini" plain style="margin-left:3px;padding:7px 8px" @click="getVal(500000)">50{{$t('tableText.만원')}}</el-button>
             <el-button type="primary" size="mini" plain style="margin-left:3px;padding:7px 8px" @click="getVal(1000000)">100{{$t('tableText.만원')}}</el-button>
             <el-button type="primary" size="mini" plain style="margin-left:3px;padding:7px 8px" @click="getVal(0)">{{$t('tableText.정정')}}</el-button>
            </el-form-item>
          </el-form>
           <div class="d-flex mt-2" style="justify-content:center"><el-input v-model="bonForm.code" type="text"  style="width: 100px; margin-right: 8px;" :placeholder="$t('searchText.인증코드')"></el-input><el-button type="primary" @click="bonSumbit" :loading ="layoutLoad">{{$t('msg.확인')}}</el-button></div>
        
        
    

	</div>
</template>

<script>
import EventBus from '../../assets/js/eventBus.js';

	export default{
		props:{
		  info:{
        type:Object,
        default:()=>{
          return {}
        }
      },
       einfo:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      layerid:{
        type:String,
        default:""
      },
		
		},
      created() {

          if(this.aid=="soft10")
          {
                this.options1=[
                {
                  label: this.$i18n.t("msg.알잔액"),
                   value: '1',
                },
                {
               
                label: this.$i18n.t("msg.카슬머니"),
                 value: '6',
               
                 }, {
                label: this.$i18n.t("msg.카슬롤링"),
                 value: '2',
               
              }];

              if(this.power=='1')
              {
                     this.options1=[
                     {
               
                      label: this.$i18n.t("msg.알잔액"),
                       value: '1',
                     
                     },{
                     
                      label: this.$i18n.t("msg.카슬머니"),
                       value: '6',
                     
                     }, {
                      label: this.$i18n.t("msg.카슬롤링"),
                       value: '2',
                     
                     }, {
                      label: this.$i18n.t("msg.파워머니"),
                       value: '4',
                     
                     }, {
                      label: this.$i18n.t("msg.파워롤링"),
                       value: '5',
                     
                     }];
              }
              if(this.rosing=='1')
              {
                     this.options1=[
                     {
               
                      label: this.$i18n.t("msg.알잔액"),
                       value: '1',
                     
                     },{
                     
                      label: this.$i18n.t("msg.카슬머니"),
                       value: '6',
                     
                     }, {
                      label: this.$i18n.t("msg.카슬롤링"),
                       value: '2',
                     
                     }, {
                      label: this.$i18n.t("msg.파워머니"),
                       value: '4',
                     
                     }, {
                      label: this.$i18n.t("msg.파워롤링"),
                       value: '5',
                     
                     }, {
                      label: this.$i18n.t("newAdd.루징머니"),
                       value: '7',
                     
                     }];
              }
         }else
         {
              if(this.sitetype=="3")
              {
                    this.options1=[{
                     
                      label: this.$i18n.t("msg.게임머니"),
                       value: '1',
                     
                    }, {
                      label: this.$i18n.t("msg.이벤트머니"),
                       value: '2',
                     
                    }, {
                      label: this.$i18n.t("msg.롤링머니"),
                       value: '3',
                     
                    }];
              }
              if(this.sitetype=="1" || this.sitetype=="2")
              {
                    this.options1=[{
                     
                      label: this.$i18n.t("msg.게임머니"),
                       value: '1',
                     
                    }, {
                      label: this.$i18n.t("msg.이벤트머니"),
                       value: '2',
                     
                    }];
              }
              else
              {
                      this.options1=[{
                     
                       label:this.$i18n.t("msg.알잔액"),
                       value: '1',
                     
                      },{
                     
                       label: this.$i18n.t("msg.카슬머니"),
                       value: '6',
                     
                      },
                       {
                       label: this.$i18n.t("msg.롤링머니"),
                       value: '2',
                     
                     }];
              }
         }

          // this.info.id父组件传给子组件的id值
          
          this.fetchManage(this.einfo.e,this.info.id,this.info.type);
          this.userbalance();
         
        
    },
		computed: {
         
            
        },
    	data(){
    		return{
          money_label:[],
          restaurants: [],
          state: '',
          timeout:  null,
          layoutLoad:false,
          mem_cash:'0',
          mem_eventmoney:'0',
          api_money:'0',
          power_cash:'0',
          power_ecash:'0',
          gubun:'',
           options1: [],
           io_type:'',
           ioType: [
               {
                label: this.$i18n.t("msg.충전"),
                 value: '1',
               
              }, {
                label: this.$i18n.t("msg.환전"),
                 value: '2',
               
              }],
    		  bonForm:{
            all:false,
            mem_id:'',
            money:'',
            memo:'',
            code:''
          },
           layLoading:false,
            rules: {
  mem_id: [{ required: true, message: '', trigger: 'blur'}],
  money: [
    {
      validator: (rule, value, callback) => {
        if (this.bonForm.all == '1') {
          // 全额时，不校验
          return callback();
        }
        if (!value) {
          return callback(new Error(''));
        }
        callback();
      },
      trigger: 'blur'
    }
  ]
},
            domain:window.sessionStorage.getItem('domain'),
            userid:window.sessionStorage.getItem('userid'),
            sitetype:window.sessionStorage.getItem('sitetype'),
            aid:window.sessionStorage.getItem('admin_id'),
            power:window.sessionStorage.getItem('power'),
            rosing:window.sessionStorage.getItem('rosing'),
    			
    		}
    	},
       mounted() {
        
            
    },
    watch: {
  'bonForm.all'(val) {
    if (val == '1') {
      this.bonForm.money = ''
    }
  }
},
    	methods:{
         
      loadAll(){
        
      },
      querySearchAsync(queryString, cb) {
       let token=window.sessionStorage.getItem('user');
           
              this.$axios({
                    method:'put',
                    url:this.domain+'/user/id_like?mem_id='+this.bonForm.mem_id,
                   
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
      
              }).then((response) =>{ 

               let item = response.data.data.data;

               this.restaurants = item;
                   // return this.restaurants;

                  var restaurants = this.restaurants;
                 //console.log('restaurants==',restaurants)
                          // 解决element建议搜索框无法显示内容 的数据处理
                          for (var i = 0; i < restaurants.length; i++) {
                            restaurants[i].value = restaurants[i].mem_id;
                          }
                          var results = queryString
                            ? restaurants.filter(this.createStateFilter(queryString))
                            : restaurants;
                          // 调用 callback 返回建议列表的数据
                          clearTimeout(this.timeout);
                          this.timeout = setTimeout(() => {
                            cb(results);
                          }, 50 * Math.random());
                                      
   
                 
              }).catch((error) =>{
                 this.$message({
                          message:'error',
                          type:'error'
                      })   

                   
              })
 
    },
    rmoney(s){
            let str = ''
            if(s){
              str = String(s).replace(/,/g,"")
            }
            if(s && (s + "").indexOf('.') > -1 && Number(str)){
              return String(s).replace(/[^\d\.-]/g, "");
            }else if(s && Number(str)){
              return str;
            }else{
              return s
            }
          },

        getBtnVal(e){
          
          this.bonForm.money =this.rmoney(e.target.innerText)
         
        },
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.mem_id.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },

      handleSelect(item) {
        console.log('item',item.mem_id);
        this.bonForm.mem_id = item.mem_id;
      },
         fetchManage(e,id,type){
           if(type == 1){
         
            this.io_type = '1'
          }if(type == 2){
           
            this.io_type = '2'
          }

          this.gubun=e+"";

        

          this.bonForm.mem_id = id
         },

         userbalance_btn(){
           this.info.id = this.bonForm.mem_id
           this.userbalance()
         },

         userbalance(){
           let token=window.sessionStorage.getItem('user');
           if(this.info.id ==''){
            this.info.id = this.bonForm.mem_id
           }

              this.layLoading = true
              this.$axios({
                    method:'get',
                    url:this.domain+'/user/userbalance?mem_id='+this.info.id,
                   
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
      
              }).then((response) =>{ 
                   
                  
                   
                    let item = response.data.data
                    if(response.data.money_select==null){
                      
                   
                    }
                    else{

                          this.options1=[];
                          this.gubun='';

                          let newids=[];                    
                          response.data.money_select.forEach(item=>{
                          let obj={};
                          obj.label=item.tname
                          obj.value=item.type

                          if(this.gubun=='')
                          {
                            this.gubun=item.type;
                          }

                          newids.push(obj);            
                         });
                         this.options1=newids
                    }
                    
                  
                    this.money_label = response.data.money_label

           
                    if(response.data.code==200){
                      this.mem_cash = item.mem_cash
                      this.mem_eventmoney = item.mem_eventmoney
                      this.api_money = item.api_money
                      this.power_cash = item.power_cash
                      this.power_ecash = item.power_ecash

                      

                    }else if(response.data.code==201){
                     
                      
                    }else
                    {
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }

                     this.layLoading = false
  
                 
              }).catch((error) =>{

                 this.layLoading = false
                 this.$message({
                          message:'error',
                          type:'error'
                      })   

                  
              })
         },
         bonSumbit(){
          let that=this

          
          if(this.bonForm.all == "1"){
          
                 this.$confirm(this.$i18n.t("newAdd.전액을회수하시겠습니까"), this.$i18n.t("msg.알림"), {
                              confirmButtonText: this.$i18n.t("msg.확인"),
                              cancelButtonText: this.$i18n.t("msg.취소"),
                              type: 'warning'
                            }).then(() => {
                              this.cash_input();

                            }).catch(() => {
                                  this.$message({
                                   type: 'info',
                                    message:this.$i18n.t("msg.취소")
                               }); 
                            });

                            
          }else
          {
             this.cash_input();
          }
          
         
        },
        cash_input(){
           this.$refs.form.validate((e)=>{
             if(!e) return;
              let token=window.sessionStorage.getItem('user');
           this.layLoading = true
           this.layoutLoad =true
              this.$axios({
                    method:'post',
                    url:this.domain+'/user/cash_event_up',
                    data:{
                      mem_id:this.bonForm.mem_id,
                      money:this.bonForm.money,
                      memo:this.bonForm.memo,
                      io_type:this.io_type,
                      gubun:this.gubun,
                      code:this.bonForm.code,
                      all:this.bonForm.all
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
      
              }).then((response) =>{ 
                   
                this.layoutLoad =false
                     this.layLoading = false
                    let item = response.data.data
                  //  console.log('data==',item)
                    if(response.data.code==200){
            

                     //this.bonForm.mem_id=''
                     this.bonForm.money=''
                     this.bonForm.memo=''
                       this.bonModel = false
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      }) 

                      this.userbalance();
                      //在这判断 layer_new打开的还是 memlist打开的
                      this.$parent.getList() 

                      EventBus.$emit('mem_cash', response.data.pt_cash)
                      EventBus.$emit('habu_apimoney', response.data.habu_apimoney)

                    }else
                    {
                       this.$alert(response.data.msg, this.$i18n.t("msg.알림"), {
                          confirmButtonText: this.$i18n.t("msg.확인"),
                          type: 'error'
                      }).catch(() => {})   
                    }
                    
                     
                
                 
              }).catch((error) =>{
                 this.$message({
                          message:'error',
                          type:'error'
                      })   

                    this.layLoading = false
              })

           })
        },
    	 getVal(e){

          if(this.bonForm.money=='')
          {
this.bonForm.money='0';
          }

          if(e=='0')
          {
            this.bonForm.money='0';
          }

          this.bonForm.money=parseInt(this.bonForm.money)+parseInt(e)
          console.log(e)
        },
    	
    	}
	}
</script>
<style>
/deep/.typeIco .el-input__icon{
  line-height: 30px;
 }
</style>


// WEBPACK FOOTER //
// src/components/common/layout-layer.vue